module.exports = __webpack_public_path__ + "img/Phillip.db3e50ce.png";